import React from 'react';
import PropTypes from 'prop-types';
import DynamicTabs from '../common/DynamicTabs';
import CRBGridsV2 from './CRBGridsV2';
import ScratchV2 from './ScratchV2';
import CACBuildRightGrid from './CACBuildRightGrid';

const SampleTabsV2 = ({ handleAnswersPreview, moveAppendToCodingBox, trackerFn, tabTracker,
  BasesDataGridData, ColumnsDataGridData, RowsDataGridData, moduleStudy, ScratchDataGridData,
  moduleWeigthType, sampleWeightedKPIs, recycleElements, rightGridList, moduleAction, isSingleBase,
  breadcrumbFlag,
 }) => {
  const getTabsList = () => {
    const tabs = [];
    rightGridList.forEach(list => {
      switch (list) {
        case 'crb': {
          tabs.push({
            title: 'Columns, Rows and Bases',
            content: (
              <CRBGridsV2
                handleAnswersPreview={handleAnswersPreview}
                moveAppendToCodingBox={moveAppendToCodingBox}
                trackerFn={trackerFn}
                BasesDataGridData={BasesDataGridData}
                ColumnsDataGridData={ColumnsDataGridData}
                RowsDataGridData={RowsDataGridData}
                ScratchDataGridData={ScratchDataGridData}
                moduleStudy={moduleStudy}
                moduleWeigthType={moduleWeigthType}
                sampleWeightedKPIs={sampleWeightedKPIs}
                recycleElements={recycleElements}
                moduleAction={moduleAction}
                scratchEnabled={rightGridList.includes('scratch')}
                breadcrumbFlag={breadcrumbFlag}
              />
            ),
          });
          break;
        }
        case 'scratch': {
          tabs.push({
            title: 'Scratch',
            content: (
              <ScratchV2
                handleAnswersPreview={handleAnswersPreview}
                moveAppendToCodingBox={moveAppendToCodingBox}
                trackerFn={trackerFn}
                moduleStudy={moduleStudy}
                BasesDataGridData={BasesDataGridData}
                ColumnsDataGridData={ColumnsDataGridData}
                RowsDataGridData={RowsDataGridData}
                ScratchDataGridData={ScratchDataGridData}
                moduleWeigthType={moduleWeigthType}
                recycleElements={recycleElements}
                moduleAction={moduleAction}
                breadcrumbFlag={breadcrumbFlag}
              />
            ),
          });
          break;
        }
        case 'cacgrid': {
          tabs.push({
            title: 'Columns, Rows, Passives and Bases',
            content: (
              <CACBuildRightGrid
                handleAnswersPreview={handleAnswersPreview}
                moveAppendToCodingBox={moveAppendToCodingBox}
                trackerFn={trackerFn}
                moduleStudy={moduleStudy}
                BasesDataGridData={BasesDataGridData}
                ColumnsDataGridData={ColumnsDataGridData}
                RowsDataGridData={RowsDataGridData}
                ScratchDataGridData={ScratchDataGridData}
                moduleWeigthType={moduleWeigthType}
                recycleElements={recycleElements}
                moduleAction={moduleAction}
                sampleWeightedKPIs={sampleWeightedKPIs}
                isSingleBase={isSingleBase}
                breadcrumbFlag={breadcrumbFlag}
              />
            ),
          });
          break;
        }
        default: break;
      }
    });
    return tabs;
  };

  return (
    <div>
      <div>
        <DynamicTabs
          tabs={getTabsList()}
          handleSelect={tabTracker}
        />
      </div>
    </div>
  );
};

SampleTabsV2.propTypes = {
  handleAnswersPreview: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  trackerFn: PropTypes.func,
  tabTracker: PropTypes.func,
  BasesDataGridData: PropTypes.arrayOf(PropTypes.shape({})),
  ColumnsDataGridData: PropTypes.arrayOf(PropTypes.shape({})),
  RowsDataGridData: PropTypes.arrayOf(PropTypes.shape({})),
  moduleStudy: PropTypes.shape({}),
  ScratchDataGridData: PropTypes.arrayOf(PropTypes.shape({})),
  moduleWeigthType: PropTypes.shape({}),
  sampleWeightedKPIs: PropTypes.shape({}),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  rightGridList: PropTypes.arrayOf(PropTypes.string),
  moduleAction: PropTypes.shape({}),
  isSingleBase: PropTypes.bool,
  breadcrumbFlag: PropTypes.bool,
};

SampleTabsV2.defaultProps = {
  rightGridList: [],
};

export default SampleTabsV2;
